import CountryCard from "./CountryCard";

export default CountryCard;
